import React from 'react';

// Component
import ListDetail from './ListDetail';

function Section12(props: any) {
  const {
    dataObj, airlines, isDesktop, company,
  } = props;

  return (
    <>
      <ListDetail
        company={company}
        isDesktop={isDesktop}
        dataObj={dataObj}
        airlines={airlines}
      />
    </>
  );
}

export default React.memo(Section12);
